import { createAction } from '@reduxjs/toolkit';

export const fetchEnums = createAction('[Enums] fetchEnums');
export const fetchEnumsSuccess = createAction('[Enums] fetchEnumsSuccess');
